import "../CSS/Ploeg.css";

function EerstePloeg() {
  return (
    <div className="ploegoverzicht">
      <img className="team" src="/EerstePloeg/Team.jpeg" alt="Team" />
      <iframe
        className="klassement"
        src="https://www.voetbalvlaanderen.be/competitie/CHP_124006/rangschikking"
      />
      <p className="positie">STAF</p>
      <div className="positieoverzicht">
        <div className="speler">
          <img src="EerstePloeg/DavidLampaert.jpg" alt="David Lampaert" />
          <p>
            <b>David Lampaert</b>
          </p>
        </div>
        <div className="speler">
          <img src="/EerstePloeg/TomDobbelaere.jpg" alt="Tom Dobbelaere" />
          <p>
            <b>Tom Dobbelaere</b>
          </p>
        </div>
        <div className="speler">
          <img src="/EerstePloeg/KyleAerens.jpg" alt="Kyle Aerens" />
          <p>
            <b>Kyle Aerens</b>
          </p>
        </div>
      </div>
      <p className="positie">DOELMAN</p>
      <div className="positieoverzicht">
        <div className="speler">
          <img src="EerstePloeg/JasperDobbelaere.jpg" alt="Jasper Dobbelaere" />
          <p>
            <b>Jasper Dobbelaere</b>
          </p>
        </div>
      </div>
      <p className="positie">VERDEDIGING</p>
      <div className="positieoverzicht">
        <div className="speler">
          <img src="/EerstePloeg/EgonRobert.jpg" alt="Egon Robert" />
          <p>
            <b>Egon Robert</b>
          </p>
        </div>
        <div className="speler">
          <img src="/EerstePloeg/ThomasVanneste.jpg" alt="Thomas Vanneste" />
          <p>
            <b>Thomas Vanneste</b>
          </p>
        </div>
        <div className="speler">
          <img
            src="/EerstePloeg/MaximVerschueren.jpg"
            alt="Maxim Verschueren"
          />
          <p>
            <b>Maxim Verschueren</b>
          </p>
        </div>
        <div className="speler">
          <img src="/EerstePloeg/WardClaerhout.jpg" alt="Ward Claerhout" />
          <p>
            <b>Ward Claerhout</b>
          </p>
        </div>
        <div className="speler">
          <img src="/EerstePloeg/SimonDeBacker.jpg" alt="Simon De Backer" />
          <p>
            <b>Simon De Backer</b>
          </p>
        </div>
        <div className="speler">
          <img src="/EerstePloeg/BasielMeesseman.jpg" alt="Basiel Meesseman" />
          <p>
            <b>Basiel Meesseman</b>
          </p>
        </div>
      </div>
      <p className="positie">MIDDENVELD</p>
      <div className="positieoverzicht">
        <div className="speler">
          <img src="/EerstePloeg/EmielDePoortere.jpg" alt="Emiel De Poortere" />
          <p>
            <b>Emiel De Poortere</b>
          </p>
        </div>
        <div className="speler">
          <img
            src="/EerstePloeg/LukasVanDenHende.jpg"
            alt="Lukas Van Den Hende"
          />
          <p>
            <b>Lukas Van Den Hende</b>
          </p>
        </div>
        <div className="speler">
          <img src="/EerstePloeg/ArneVerstraete.jpg" alt="Arne Verstraete" />
          <p>
            <b>Arne Verstraete</b>
          </p>
        </div>
        <div className="speler">
          <img src="/EerstePloeg/MaximeMahy.jpg" alt="Maxime Mahy" />
          <p>
            <b>Maxime Mahy</b>
          </p>
        </div>
        <div className="speler">
          <img
            src="/EerstePloeg/RubenDeceukelier.jpg"
            alt="Ruben Deceukelier"
          />
          <p>
            <b>Ruben Deceukelier</b>
          </p>
        </div>
      </div>
      <p className="positie">AANVAL</p>
      <div className="positieoverzicht">
        <div className="speler">
          <img src="/EerstePloeg/JonasBlancke.jpg" alt="Jonas Blancke" />
          <p>
            <b>Jonas Blancke</b>
          </p>
        </div>
        <div className="speler">
          <img src="/EerstePloeg/TimMuysoms.jpg" alt="TimMuysoms" />
          <p>
            <b>Tim Muysoms</b>
          </p>
        </div>
        <div className="speler">
          <img src="/EerstePloeg/FinnErvynck.jpg" alt="Finn Ervynck" />
          <p>
            <b>Finn Ervynck</b>
          </p>
        </div>
        <div className="speler">
          <img
            src="/EerstePloeg/HannesWulteputte.jpg"
            alt="Hannes Wulteputte"
          />
          <p>
            <b>Hannes Wulteputte</b>
          </p>
        </div>
      </div>
    </div>
  );
}

export default EerstePloeg;
